/**
 * CONFLICT: 이미 가입된 회원
 * SUCCESS: 로그인 성공
 * FAIL: 로그인 실패
 * SIGNUP: 회원가입 필요
 */
export const OAuthResponseState = {
  CONFLICT: 'CONFLICT', // 이미 가입된 회원
  SUCCESS: 'SUCCESS', // 로그인 성공
  FAIL: 'FAIL', // 로그인 실패
  SIGNUP: 'SIGNUP', // 회원가입 필요
} as const;
